export default __webpack_public_path__ + "static/flash-e1b5568b3c8287c2d2726a04f690893e.jpg";